import { render } from "./LogInPage.vue?vue&type=template&id=067fa22d&scoped=true&ts=true"
import script from "./LogInPage.vue?vue&type=script&lang=ts"
export * from "./LogInPage.vue?vue&type=script&lang=ts"

import "./LogInPage.vue?vue&type=style&index=0&id=067fa22d&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067fa22d"]])

export default __exports__